import PropTypes from 'prop-types';

const SITUATION_FIELDS = [
  { label: 'Counterpart',        getValue: cs => cs?.characterBrief?.inSum?.content },
  { label: 'Real Issue',  getValue: cs => cs?.realIssue?.summary?.content },
  { label: 'Data & Reasoning',   getValue: cs => cs?.realIssue?.dataAndReasoning?.content },
  { label: 'Stakes — Downsides', getValue: cs => cs?.characterStakes?.downSides?.inSum?.content },
  { label: 'Stakes — Upsides',   getValue: cs => cs?.characterStakes?.upSides?.inSum?.content },
  { label: 'Desired Outcome',    getValue: cs => cs?.desiredOutcome?.content },
  { label: 'Challenge',          getValue: cs => cs?.challenge?.content },
];

const KnowledgeSituationPanel = ({ caseStudy }) => {
  return (
    <div className="rp-knowledge-situation-panel">
      <div className="rp-script-header">
        <span className="rp-script-tab active">Situation</span>
      </div>
      <div className="rp-script-list">
        {!caseStudy ? (
          <p className="rp-script-empty">Situation not yet available.</p>
        ) : (
          SITUATION_FIELDS.map(({ label, getValue }) => {
            const value = getValue(caseStudy);
            if (!value) return null;
            return (
              <div key={label} className="rp-impl-cs-section">
                <div className="rp-impl-cs-label">{label}</div>
                <div className="rp-impl-cs-value">{value}</div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

KnowledgeSituationPanel.propTypes = {
  caseStudy: PropTypes.object,
};

export default KnowledgeSituationPanel;
